import type {
  ApiModelInlineCitation,
  Citation,
  File,
  JsonSchemaMetadata,
} from "@alaffia-technology-solutions/schema";

import {
  TaskArtifactOutput,
  TaskArtifactOutputJsonSchema,
} from "@alaffia-technology-solutions/schema";

export function parseTaskArtifactOutput(
  unparsedContent: unknown,
  unparsedSchema: unknown,
) {
  if (unparsedSchema == null || unparsedContent == null) return null;

  const schemaResult = TaskArtifactOutputJsonSchema.safeParse(unparsedSchema);
  if (schemaResult.error) {
    console.warn("Error parsing agent schema", schemaResult.error);
    return null;
  }
  const schema = schemaResult.data;

  const contentResult = TaskArtifactOutput.safeParse(unparsedContent);
  if (contentResult.error) {
    console.warn("Error parsing agent content", contentResult.error);
    return null;
  }
  const content = contentResult.data;

  return {
    markdown: {
      propertyPath: "/markdown",
      content: content.markdown,
      editable: isPropertyEditable(schema.properties.markdown),
    },
    citations: {
      propertyPath: "/citations",
      content: groupCitationsByFileId(content.citations),
    },
    inline_citations: {
      content: content.inline_citations,
      keyMap: buildInlineCitationKeyMap(content.inline_citations),
    },
  };
}

export type ParsedTaskArtifactOutput = ReturnType<
  typeof parseTaskArtifactOutput
>;

function buildInlineCitationKeyMap(
  inlineCitations: ApiModelInlineCitation[],
): Record<string, ApiModelInlineCitation> {
  return Object.fromEntries(inlineCitations.map((ic) => [ic.key, ic]));
}

export function groupCitationsByFileId(citations: Citation[]) {
  return citations.reduce<Record<File["id"], Citation[]>>((acc, citation) => {
    const citationsInSameFile = acc[citation.file_id] ?? [];
    return {
      ...acc,
      [citation.file_id]: [...citationsInSameFile, citation],
    };
  }, {});
}

function isPropertyEditable(
  propertySchema: { metadata?: JsonSchemaMetadata } | undefined,
) {
  return propertySchema?.metadata?.UI_ACTION?.includes("edit") ?? false;
}
